import React from "react";

function Modal({ isOpen, onClose }) {
  if (!isOpen) return null; // Don't render if closed

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[#231F21] bg-opacity-50 z-50"
      onClick={onClose} // Clicking background closes modal
    >
      <div
        className="bg-white p-6 rounded-[28px] shadow-lg max-w-md w-full"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <h2 className="uppercase font-bold" style={{ color: "black", fontSize: "small"}}>
          How Did We Arrive at This Number?
        </h2>
        <p className=" mt-2 pb-4 font-normal text-[32px] leading-tight font-barlow">
          Our price calculation is based on historical trends, real-time
          supplier data, and market analysis to provide accurate pricing
          insights.
        </p>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-[#E8EA58] text-[#231F21] transition-transform duration-200 transform hover:scale-105 uppercase font-bold"

        >
          Got it!
        </button>
      </div>
    </div>
  );
}

export default Modal;
